import { Alert, AlertTitle, Button, Typography } from '@mui/material'
import { observer } from 'mobx-react-lite'
import { useNavigate } from 'react-router-dom'
import { useStore } from '@hooks/useStore'
import { BILLING_CONSTANTS } from '@constants'

export const ReadOnlyBanner: React.FC = observer(() => {
  const { billing } = useStore()
  const navigate = useNavigate()

  if (!billing.isReadOnly) return null

  return (
    <Alert
      severity="warning"
      sx={{ mb: 3 }}
      action={
        <Button
          color="inherit"
          size="small"
          variant="contained"
          onClick={() => navigate('/instellingen?tab=subscription')}
        >
          {BILLING_CONSTANTS.MESSAGES.UPGRADE_CTA}
        </Button>
      }
    >
      <AlertTitle>{BILLING_CONSTANTS.MESSAGES.READ_ONLY_TITLE}</AlertTitle>
      <Typography variant="body2">{BILLING_CONSTANTS.MESSAGES.READ_ONLY_INFO}</Typography>
    </Alert>
  )
})
